import React from 'react';
import Link from 'gatsby-link';
import YouTube from 'react-youtube';
import Aspect from '../utils/aspect-wrapper';

const IndexPage = () => (
  <div>
    <h1>Legacy of the Stars</h1>
    <h2>An epic space strategy game inspired by PC 4x classics</h2>
    <Aspect ratio={16 / 9}>
      <YouTube videoId="MSj5Ly7BBrs" opts={{ width: '100%', height: '100%' }} />
    </Aspect>
    <p>
      Legacy of the Stars is a space empire-building game in which you take
      control of one of eight unique factions racing to rebuild human
      civilization after a devastating galactic civil war. Your goal is to be
      the faction whose legacy will shape humanity&apos;s future by collecting
      Legacy Cards representing your accomplishments—from expansion to economy,
      technology, and bloody conquest. The first one to claim eight Legacy Cards
      is the winner.
    </p>
    <p>
      Legacy of the Stars uses an innovative and intuitive action-card driven
      core mechanic that gives you plenty of weighty decisions without leaving
      the results up to chance. Diplomacy is enhanced by the Glory and Vengeance
      mechanics, which reward powerful empires for conquering territory from one
      another instead of picking on weaker neighbors. Meanwhile, the Legacy
      Track presides over the dramatic arc of the game, injecting events that
      give everyone access to Covert Operations, powerful Leaders unique to each
      faction, and windfalls of resources and technology.
    </p>
    <p>
      The most recent PDF game manual is available on the <Link to="/manual">Manual page</Link>.
    </p>
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js